import { useState } from "react";
import { Card } from "react-bootstrap";
import { ChevronExpand } from "react-bootstrap-icons";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectMeasurementType } from "../../../../store/slices/settingsSlice";

function InfoBoxCompression() {
  const { t } = useTranslation("translation", "fhwa");

  const [showResults, setShowResults] = useState(true);
  const onClick = () => setShowResults(!showResults);
  const metric = useSelector(selectMeasurementType);
  let isMetric = metric === 0;

  return (
    <div className="col-8" style={{ paddingTop: "10px" }}>
      <Card bg={"light"} key={1} text={"dark"} style={{ width: "100%" }} className="mb-2">
        <Card.Header onClick={onClick}>
          {t("aashto.inner.Compression")}
          <button type="button" className="float-end" style={{ border: "none" }}>
            {showResults ? t("hideDetails") : t("showDetails")}
            <ChevronExpand style={{ marginLeft: "10px" }} />
          </button>
        </Card.Header>

        {showResults && (
          <Card.Body>
            <p>
              P<sub>c-allowable</sub> = (&alpha; &sdot; f<sup>'c</sup> &sdot; A<sub>grout</sub> +
              &gamma; &sdot; F<sub>y-bar</sub> &sdot; A<sub>bar</sub>)
            </p>
            <br />
            <dl style={{ color: "#3f3f40", fontSize: "12px" }}>
              <dt>&alpha;</dt>
              <dd>{t("SafetyFactorGroutDesign", { ns: "fhwa" })}</dd>
              <dt>
                f<sup>'c</sup>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.inner.fc_Description"
                  values={{
                    unit: isMetric ? "MPa" : "ksi",
                  }}
                />
              </dd>

              <dt>
                A<sub>g</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.inner.Ag_Description"
                  values={{
                    unit: isMetric ? "mm²" : "in²",
                  }}
                />
              </dd>
              <dt>&gamma;</dt>
              <dd>{t("SafetyFactorSteel", { ns: "fhwa" })}</dd>
              <dt>
                F<sub>y</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.inner.Fy_Description"
                  values={{
                    unit: isMetric ? "MPa" : "ksi",
                  }}
                />
              </dd>
              <dt>
                A<sub>b</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="aashto.inner.Ab_Description"
                  values={{
                    unit: isMetric ? "mm²" : "in²",
                  }}
                />
              </dd>
            </dl>
          </Card.Body>
        )}
      </Card>
    </div>
  );
}

export default InfoBoxCompression;
